<!-- Start Our Works Area -->
<section id="works" class="our-works ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 offset-lg-2 text-center">
                <div class="section-title">
                    <h2>Captain Steel (Pvt) Ltd</h2>
                    <p>Captain Steel (Pvt) Ltd, a leading steel manufacturer in Sri Lanka, is renowned for its quality and reliability in providing industrial solutions. To enhance its online presence, a comprehensive Facebook marketing strategy was executed</p>
                    
                    <p>Captain Steel's digital marketing strategy focused on creating engaging content, running interactive campaigns, targeting ads to construction and manufacturing sectors, and analyzing performance metrics to boost brand visibility and engagement.</p>
                    
                    <p>These initiatives significantly boosted Captain Steel's brand visibility and reinforced its position as a trusted steel solutions provider.</p>
                    <span class="section-title-bg">Captain</span>
                </div>
            </div>
        </div>

        <div id="Portfolio" class="row">
            <div class="col-sm-6 col-lg-4 filtr-item web" *ngFor="let image of album; let i=index">
                <div class="work-details" (click)="open(i)" *ngIf="image.type == 'image'">
                    <img [src]="image.thumb" [alt]="image.caption">
                </div>

                <div class="work-details popup-youtube" [attr.href]="image.link" *ngIf="!(image.type == 'image')">
                    <div class="videos">
                        <a href="#" class="video">
                          <span></span>
                          <img [src]="image.thumb" [alt]="image.caption">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Our Works Area -->
